// extracted by mini-css-extract-plugin
module.exports = {"dropdownLabel":"DropdownLabel_dropdownLabel__CRuBZ","chevronDownIcon":"DropdownLabel_chevronDownIcon__cXf3V","active":"DropdownLabel_active__oVGOv"};